import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import District from '../../../api/models/district';
import { getDistricts } from '../../../api/services/districtService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';

type ViewState = {
  message?: string;
};

const ViewDistricts = () => {
  const columns = React.useMemo(
    () => [
      {
        id: 'districtColumn',
        Header: 'District',
        accessor: 'name',
      },
      {
        Header: 'Division',
        accessor: (d: any) => d.division.name,
      },
      {
        Header: 'State',
        accessor: (d: any) => d.state.name,
      },
      {
        id: 'isVisible',
        Header: 'Is Visible',
        accessor: (d: any) => (d.isVisible ? 'Yes' : 'No'),
      },
      {
        accessor: 'districtId',
        disableSortBy: true,
        Cell: (props: any) => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon
                  className='w-5 h-5 cursor-pointer'
                  aria-hidden='true'
                />
              </span>
            </div>
          );
        },
        className: 'hidden sm:table-cell',
      },
    ],
    []
  );
  const defaultSort = React.useMemo(
    () => [
      {
        id: "districtColumn",
        desc: false
      }
    ],
    []
  );
  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [districts, setDistricts] = useState<District[]>([]);
  const [initialState, setInitialState] = useState<{}>({ sortBy: defaultSort, sortType: "ci" });

  const { error, isPending } = useAsync({
    promiseFn: getDistricts,
    onResolve: (r) => {
      setDistricts(r.data.districts.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      }));
    },
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification>{state?.message}</Notification>}

        <div className='mb-4 text-right'>
          <Link className='btn' to='/admin/districts/new'>
            Add District
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={districts}
          initialState={initialState}
          showPagination={true}
          getRowProps={(row: any) => ({
            className: row.original.isMyMessage
              ? 'cursor-pointer hover:bg-purple-300 bg-purple-200'
              : 'cursor-pointer hover:bg-gray-100',
            onClick: () =>
              history.push(`/admin/districts/${row.values.districtId}`),
          })}
        />
      </Fragment>
    </Layout>
  );
};

export default ViewDistricts;
